// 菜单页的配置数据
// key 对应router导航的配置
// value 对应展示的菜单名称
// sub 对应子菜单项
export default {
	data: [
		{
			key: "index",
			value: "For Advertisers"
		},
		{
			key: "advantage",
			value: "AD Solutions",
			sub: [
				{
					key: "flow",
					value: "Top Media  Marketing"
				},
				{
					key: "ai",
					value: "Influence Marketing"
				},
				{
					key: "content",
					value: "Exlusive Traffice Aggergation"
				}
			]
		},
		{
			key: "case",
			value: "Case Studies"
		},
		{
			key: "flow_to_cash",
			value: "For Publishers",
			sub: [
				{
					key: "flow_to_cash",
					value: "Influence Creators"
				},
				{
					key: "Publishers",
					value: "Publishers & devolpers"
				}
			]
		},
		{
			key: "news",
			value: "Events"
		},
		{
			key: "about",
			value: "About Us"
		},
		{
			key: "all",
			value: "≡",
			reactiveSub: [
				{
					key: "index",
					value: "For Advertisers"
				},
				{
					key: "flow",
					value: "Top Media Integration Marketing Solution"
				},
				{
					key: "ai",
					value: "Oversea Influencer Marketing Solution"
				},
				{
					key: "content",
					value: "Exclusive Traffic Aggregation Solution"
				},
				{
					key: "case",
					value: "Case Studies"
				},
				{
					key: "flow_to_cash",
					value: "For Creators"
				},
				{
					key: "Publishers",
					value: "For Publishers"
				},
				{
					key: "news",
					value: "Events"
				},
				{
					key: "about",
					value: "About Us"
				}
			]
		}
	]
};



// WEBPACK FOOTER //
// ./src/data/tab.js